export function getTitleWithParsedEpisode(_title?: string | null) {
  if (!_title) {
    return {
      title: '',
      episode: undefined,
    };
  }

  const [title, episode] = _title.split(/((\d+[화권])|트레일러|PV)$/g);

  if (!title && episode) {
    return {title: episode.trim(), episode: undefined};
  }

  return {title: title.trim(), episode};
}
